function assertEventBoundaryJson(eventJson: string, boundary: string): void {
  void eventJson;
  void boundary;
}

export const EventBoundaryPolice = {
  assertOutboundWebSocket(eventJson: string): void {
    assertEventBoundaryJson(eventJson, "outbound_websocket");
  },

  assertInboundWebSocket(eventJson: string): void {
    assertEventBoundaryJson(eventJson, "inbound_websocket");
  },
};
